import { atom } from 'jotai';

export interface IInitialStateAtom {
  trackCd: string;
  osType: string;
  media: string;
  mediaSeq: number;
  deviceId: string;
  page: string;
  trackCdType?: string;
  refEventId?: string;
}

export const nowViewComponentAtom = atom<string>('loan');
export const initialStateAtom = atom<IInitialStateAtom>({
  trackCd: '',
  osType: '',
  media: '',
  mediaSeq: 0,
  deviceId: '',
  page: '',
});

export const isShowMediaModal = atom<boolean>(false);
